import "./Label.scss";

const Label = ({ id, label, color, className, centered = true }) => {
  return (
    <div
      id={`label-${id}`}
      className={`input-label ${color} ${className}`}
      style={{ textAlign: centered ? "center" : "unset" }}
    >
      {label}
    </div>
  );
};

export default Label;
